import { Component, OnInit, effect, input, model, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { sanitizeFields, validateBlank, validateYearsLimitFromToday, watchFormRecursively } from '../../../shared/utils/form-utils';

import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormFieldFeedbackPipe } from '../../../pipes/form-field-feedback/form-field-feedback.pipe';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { VaccineHistory } from '../../../shared/models/vaccine-history.model';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-vaccine-history-form',
  imports: [
    ButtonModule,
    ReactiveFormsModule,
    FormFieldFeedbackPipe,
    TooltipModule,
    DatePickerModule,
    TextareaModule,
    InputTextModule,
    FloatLabelModule
  ],
  templateUrl: './vaccine-history-form.component.html',
  styleUrl: './vaccine-history-form.component.scss'
})
export class VaccineHistoryFormComponent {
  readonly vaccineHistoryForm = new FormGroup({
    name: new FormControl<string>('', {
      validators: [
        Validators.required,
        validateBlank()
      ]
    }),
    date: new FormControl<Date>(new Date(), {
      validators: [
        Validators.required,
        validateYearsLimitFromToday(20, true)
      ]
    }),
    dose: new FormControl<string>('', {
      validators: [
        Validators.required,
        validateBlank()
      ]
    }),
    nextDose: new FormControl<Date>(new Date()),
    detail: new FormControl<string>('')
  });

  readonly today = new Date();

  readonly initialData = input<VaccineHistory | null>(null);
  readonly onSubmit = output<any>();
  readonly enabled = model<boolean>(true);
  readonly isLoading = model<boolean>(false);

  readonly formWatched = watchFormRecursively(this.vaccineHistoryForm);
  readonly id = uuidv4();


  constructor(private readonly messageService: MessageService) {
    effect(() => {
      if (this.enabled()) {
        this.vaccineHistoryForm.enable();
      } else {
        this.vaccineHistoryForm.disable();
      }
    });

    effect(() => {
      if (this.initialData()) {
        this.enabled.set(false);
        this.vaccineHistoryForm.patchValue(this.initialData()!);
      } else {
        this.enabled.set(true);
        this.resetForm();
      }
    });
  }

  resetForm(): void {
    this.vaccineHistoryForm.reset();
    this.isLoading.set(false);
  }

  submitForm(): void {
    this.isLoading.set(true);

    if (this.vaccineHistoryForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha todos os campos corretamente!',
        life: 4000
      });

      this.isLoading.set(false);
      return;
    }

    sanitizeFields(this.vaccineHistoryForm);
    this.onSubmit.emit(this.vaccineHistoryForm.value);
  }
}
